var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#424F62",
    d: "M18.177 5.163H2.808l3.667-3.734c.322-.327.322-.857 0-1.184-.32-.327-.842-.327-1.163 0L.241 5.408c-.321.327-.321.857 0 1.184l5.071 5.163c.161.163.371.245.582.245.21 0 .42-.082.581-.245.322-.327.322-.857 0-1.184L2.808 6.837h15.37c.454 0 .822-.375.822-.837 0-.462-.368-.837-.823-.837z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.14ccef5924dbd04b86e4e89f1d0b89a7.svg";
export { ForwardRef as ReactComponent };